import { createStore, applyMiddleware, combineReducers } from "redux"
import thunk from "redux-thunk"
import { createLogger } from "redux-logger"

import AuthenticationReducer from "../services/authentication/reducers"
import NotificationsReducer from "../services/notifications/reducers"
import PlansReducer from "../services/plans/reducers"
import GuardiansReducer from "../services/guardians/reducers"

const rootReducer = combineReducers({
  AuthenticationReducer,
  NotificationsReducer,
  PlansReducer,
  GuardiansReducer
})

const loggerMiddleware = createLogger({
  predicate: () => process.env.NODE_ENV === "development"
})

const middleWare = [thunk, loggerMiddleware]

export default function configureStore() {
  return createStore(rootReducer, applyMiddleware(...middleWare))
}

export const store = configureStore()
